import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DialogService } from "primeng/dynamicdialog";
import { UserService } from "../../../shared";
import { DistrictEditGradeLevelComponent } from "./district-edit-grade-level/district-edit-grade-level.component";
import { DataService_GradeLevelSetup } from "./shared/data.service";

@Component({
	selector: "app-grade-level-setup",
	templateUrl: "./grade-level-setup.component.html",
	styleUrls: ["./grade-level-setup.component.css"],
})
export class GradeLevelSetupComponent implements OnInit {
	constructor(
		private userService: UserService,
		private GradeLevelSetupService: DataService_GradeLevelSetup,
		private dialogService: DialogService,
		private confirmationService: ConfirmationService
	) {}

	//INSERT ON INIT HERE
	ngOnInit(): void {
		this.user = this.userService.getCurrentUser();

		this.loadGradeLevel();
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	///////////////
	// Built-In
	///////////////

	user: any;
	pagerows: any = 10;
	pagefirst: any = 0;
	loading: any = false;
	errorMessage: any = "";

	///////////////

	///////////////
	// Custom
	///////////////

	//Main
	SelectedGradeLevel: any;
	lstGradeLevel: any = [];

	//Filter lists

	//Cols
	cols: any = [
		//INSERT CUSTOM COLUMNS HERE
		// { field: 'ZOrder', header: 'Order' },
		{ field: "GradeLevelCD", header: "Grade Code" },
		{ field: "GradeLevelDesc", header: "Grade" },
		{
			field: "MealAccountCreditLimit",
			header: "Meal Account Maximum Negative Amount",
		},
	];

	///////////////

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////

	loadGradeLevel() {
		this.loading = true;

		var result = this.GradeLevelSetupService.LoadGradeLevel();
		result.subscribe(
			(response) => {
				this.lstGradeLevel = response;

				//Load Data Filter Lists

				this.loading = false;
			},
			(error) => {
				this.loading = false;
			}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////

	onRefresh() {
		this.errorMessage = "";

		this.loadGradeLevel();

		this.onRowUnselect(null);
	}

	//Custom Button Methods
	onEditGradeLevel() {
		this.errorMessage = "";

		if (this.SelectedGradeLevel == undefined) {
			this.errorMessage = "Select a grade level to edit";
			return;
		}

		var ref = this.dialogService.open(DistrictEditGradeLevelComponent, {
			header: "Edit Grade Level",
			width: "fit-content",
			data: {
				//INSERT Custom Data here
				SelectedGradeLevel: this.SelectedGradeLevel,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.onRowUnselect(null);
				this.loadGradeLevel();
			}
		});
	}

	onMoveUp() {
		this.errorMessage = "";

		//Error handling
		if (this.SelectedGradeLevel == undefined) {
			this.errorMessage = "Select a grade level to change its position";
		}

		var CurrentIndex: any;
		for (var i = 0; i < this.lstGradeLevel.length; i++) {
			var next = this.lstGradeLevel[i];

			if (next.GradeLevelID == this.SelectedGradeLevel.GradeLevelID) {
				CurrentIndex = i;
				break;
			}
		}

		if (CurrentIndex == 0) {
			this.errorMessage = "Cannot move up anymore, the selected Grade Level is already at the top.";
			return;
		}

		var NextIndex = CurrentIndex - 1;

		//Call SP
		var result = this.GradeLevelSetupService.DistrictGradeLevelMoveUp(this.SelectedGradeLevel.GradeLevelID, this.lstGradeLevel[NextIndex].GradeLevelID);
		result.subscribe(
			(response) => {
				if (response) {
					this.loadGradeLevel();
					this.onRowUnselect(null);
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "main",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not change the Grade Level's order",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	onMoveDown() {
		this.errorMessage = "";

		//Error handling
		if (this.SelectedGradeLevel == undefined) {
			this.errorMessage = "Select a grade level to change its position";
		}

		var CurrentIndex: any;
		for (var i = 0; i < this.lstGradeLevel.length; i++) {
			var next = this.lstGradeLevel[i];

			if (next.GradeLevelID == this.SelectedGradeLevel.GradeLevelID) {
				CurrentIndex = i;
				break;
			}
		}

		if (CurrentIndex == this.lstGradeLevel.length - 1) {
			this.errorMessage = "Cannot move down anymore, the selected Grade Level is already at the bottom.";
			return;
		}

		var NextIndex = CurrentIndex + 1;

		//Call SP
		var result = this.GradeLevelSetupService.DistrictGradeLevelMoveDown(this.SelectedGradeLevel.GradeLevelID, this.lstGradeLevel[NextIndex].GradeLevelID);
		result.subscribe(
			(response) => {
				if (response) {
					this.loadGradeLevel();
					this.onRowUnselect(null);
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "main",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not change the Grade Level's order",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////
	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {
		this.errorMessage = "";

		this.SelectedGradeLevel = val.data;
	}
	onRowUnselect(val) {
		this.errorMessage = "";

		this.SelectedGradeLevel = null;
	}
	onRowDblClick(GradeLevel) {
		this.errorMessage = "";

		this.SelectedGradeLevel = GradeLevel;
		this.onEditGradeLevel();
	}
	////////////////////////////////////////////
}
